import { Box, styled } from '@mui/material'

/**
 * A wrapper component for tables that provides horizontal scrolling.
 * Use this to wrap table components to ensure they're scrollable on narrow screens.
 *
 * @example
 * <TableWrapper>
 *   <GrowthRateTable data={data} />
 * </TableWrapper>
 */
export const TableWrapper = styled(Box)(({ theme }) => ({
  overflowX: 'auto',
  marginBottom: 0,
}))

export default TableWrapper
